/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.7.22",
    versionName: "0.2.0-nightly.2025.7.22",
    versionChannel: "nightly",
    buildDate: "2025-07-22T00:08:27.184Z",
    commitHash: "4b916ca13112a04b07713570cea2db4c321d540d",
};
